module.exports = __webpack_public_path__ + "static/media/V-Passport web add editables-01.7cc90143.png";